import { combineReducers } from "redux"

import leadsReducer from "./leads/reducer"
import headerReducer from "./header/reducer"

export const rootReducer = combineReducers({
  leads: leadsReducer,
  header: headerReducer,
})
